import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';

import { textToKey } from '../../lib/i18n-utils';
import { Select } from '../Select/Select';

const t = i18n(keyset);

type I18NLiteral = keyof (typeof keyset)[keyof typeof keyset];

interface Option {
    value: string;
    text: string;
}

interface MonitoringPageSelectProps {
    options: Option[];
    value: string;
    namespace: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export const MonitoringPageSelect: React.FC<MonitoringPageSelectProps> = ({
    options,
    value,
    namespace,
    onChange,
    disabled,
}) => {
    return (
        <Select
            namespace={namespace}
            type="radio"
            value={value}
            disabled={disabled}
            onChange={(value) => {
                onChange(value);
            }}
            options={options.map(({ text, value }) => ({ value: value, text: t(textToKey(text) as I18NLiteral) }))}
        />
    );
};
